<template>
    <div class="mamMaster-follow-setting follow-setting">
        <div class="content pc-padding30-mobil-padding20 white border-radius5">
            <el-form>
                <el-form-item>
                    <p class="self-label">{{$t('withgold.accountNumber')}}</p>
                    <el-input
                            disabled
                            :value="login"></el-input>
                </el-form-item>
                <el-form-item>
                    <p class="self-label">{{$t('nickname')}}</p>
                    <el-input
                            disabled
                            :value="alias"></el-input>
                </el-form-item>
                <el-form-item>
                    <p class="self-label">{{$t('Identity')}}</p>
                    <el-input disabled :value="$t('MAM_master_account')"></el-input>
                </el-form-item>
            </el-form>
            <mam-master-setting
                    ref="settingform"
                    :form-data="formData"
                    @send-form="sendFormHandle"
            >
            </mam-master-setting>
        </div>
        <div class="btn-outer display-flex flex-start">
          <vs-button
            @click="saveHandle"
          >{{$t('User.saveSetting')}}</vs-button>
        </div>
    </div>
</template>

<script>
    import { getSelectList,getProportionPrefixList } from '@/utils/common'
    import { queryLoginConfig,updateLoginConfig } from '@/api/config'
    import mamMasterSetting from '@/components/common/mamMasterSetting'
  export default {
    name: 'index',
    components:{
      mamMasterSetting
    },
    props: {
      accountMtId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        formData:{
          isOpen: false,
          strategy: '',
          limit: '',
          copyPassword: '',
          isCharge: false,
          managementFee: '',
          sharePrice: []
        },
        alias: '',
        login: '',
      };
    },
    created(){
      this.queryConfig();
    },
    methods: {
      queryConfig(){
        queryLoginConfig({
          mtId: this.accountMtId
        }).then((res) => {
          this.alias = res.data.alias;
          this.login = res.data.login;
          if(res.data.isOpen){
            this.formData.isOpen = res.data.isOpen ? true: false;
            this.formData.strategy = res.data.tradeStrategy;
            this.formData.limit = res.data.subAmount || '';
            this.formData.copyPassword = res.data.subPassword;
            this.formData.isCharge = res.data.isFree ? false : true;
            if(!res.data.isFree){
              this.formData.managementFee = res.data.price;
            }
          }
          if(res.data.sharePrice){
            for (let i = 0; i < res.data.sharePrice.length; i++) {
              res.data.sharePrice[i].selectList = getSelectList(res.data.sharePrice,i);
            }
            this.formData.sharePrice = res.data.sharePrice;
          }else {
            let defaultSharePrice = [
                  {
                    shareValue: '',
                    profitValue: '',
                    selectList: getProportionPrefixList()
                  }
              ];
            this.formData.sharePrice = defaultSharePrice;
          }
        })
      },

      saveHandle(){
        this.$refs.settingform.validate();
      },
      sendFormHandle(editForm){
        this.$confirm(this.$t('mamMasterSettingSaveTips'), this.$t('attention_please'), {
          confirmButtonText: this.$t('root.confirm'),
          cancelButtonText: this.$t('root.cancle'),
          type: 'warning',
          customClass: 'self-messagebox-wrapper',
          dangerouslyUseHTMLString: true
        }).then(() => {
          let params = {
            mtId: this.accountMtId,
            isOpen: editForm.isOpen ? 1: 0,
            isFree: editForm.isCharge ? 0: 1,
          };
          if(editForm.isOpen){
            if(editForm.strategy){
              params.tradeStrategy = editForm.strategy;
            }
            if(editForm.limit){
              params.subAmount = editForm.limit;
            }
            if(editForm.copyPassword){
              params.subPassword = editForm.copyPassword;
            }
          }
          if(editForm.isCharge){
            if(editForm.managementFee){
              params.price = editForm.managementFee
            }
            for (let i = 0; i < editForm.sharePrice.length; i++) {
              delete editForm.sharePrice[i].selectList;
            }
            params.sharePrice = editForm.sharePrice;
          }
          updateLoginConfig(params).then((res) => {
            this.$message({
              type: 'success',
              message: this.$t('Saved_successfully')
            })
          })
        }).catch(() => {
          //几点取消的提示
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
.mamMaster-follow-setting {
    .content {
      padding-bottom: 10px;
    }
    .module-header {
        height: 60px;
        line-height: 60px;
    }
}
</style>
